"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Context = _interopRequireDefault(require("./Context"));

var _qs = _interopRequireDefault(require("qs"));

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Applies a function to a primitive, an object, an array or a combination of
 * the three.
 *
 * Example:
 *
 * mapValuesDeep({movie: 'lotr', names: ['frodo', 'sam', 'gandalf']}, _.upperFirst)
 *
 * {
 *   movie: 'Lotr',
 *   names: ['Frodo', 'Sam', 'Gandalf']
 * }
 */
var mapValuesDeep = function mapValuesDeep(obj, fn, key) {
  return (0, _lodash.isArray)(obj) ? (0, _lodash.map)(obj, function (innerObj, idx) {
    return mapValuesDeep(innerObj, fn, idx);
  }) : (0, _lodash.isPlainObject)(obj) ? (0, _lodash.mapValues)(obj, function (val, key) {
    return mapValuesDeep(val, fn, key);
  }) : (0, _lodash.isObject)(obj) ? obj : fn(obj, key);
};

var Form =
/*#__PURE__*/
function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Form)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isValid: true,
      isPristine: true
    });

    _defineProperty(_assertThisInitialized(_this), "fields", new Map());

    _defineProperty(_assertThisInitialized(_this), "fieldValidity", {});

    _defineProperty(_assertThisInitialized(_this), "registerField", function (field) {
      var id = (0, _lodash.uniqueId)();

      _this.fields.set(id, field);

      return id;
    });

    _defineProperty(_assertThisInitialized(_this), "unregisterField", function (field) {
      _this.fields.delete(field.id);

      delete _this.fieldValidity[field.props.name];

      _this.computeFormValidity();
    });

    _defineProperty(_assertThisInitialized(_this), "getValues", function () {
      var getFieldValueByID = function getFieldValueByID(fieldId) {
        return _this.fields.get(fieldId).getValue();
      }; // Use field IDs as values in the querystring to avoid stringifying the actual values


      var dataParts = Array.from(_this.fields.values()).map(function (field) {
        return "".concat(field.props.name, "=").concat(field.id);
      }); // Replace all the field IDs in the object with the field values

      return mapValuesDeep(_qs.default.parse(dataParts.join('&')), getFieldValueByID);
    });

    _defineProperty(_assertThisInitialized(_this), "computeFormValidity", function () {
      var formIsValid = true;
      Object.keys(_this.fieldValidity).map(function (k) {
        if (_this.fieldValidity[k] === false) formIsValid = false;
      });

      _this.setState({
        isValid: formIsValid
      }, function () {
        return _this.props.onValuesChange(_this.getValues(), formIsValid);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "validated", function (field, valid) {
      _this.fieldValidity[field.props.name] = valid;

      _this.computeFormValidity();
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function () {
      return _this.baseSubmit();
    });

    _defineProperty(_assertThisInitialized(_this), "formSubmit", function (e) {
      e.preventDefault();

      _this.baseSubmit();
    });

    _defineProperty(_assertThisInitialized(_this), "baseSubmit", function () {
      var values = _this.getValues();

      if (_this.props.onSubmit) _this.props.onSubmit(values);

      if (_this.state.isValid) {
        if (_this.props.onValidSubmit) _this.props.onValidSubmit(values);
      } else {
        if (_this.props.onInvalidSubmit) _this.props.onInvalidSubmit(values);
      }

      _this.fields.forEach(function (field) {
        field.setPristine(false);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "valueChanged", function () {
      if (_this.state.isPristine) _this.setState({
        isPristine: false
      });

      _this.props.onValuesChange(_this.getValues(), _this.state.isValid);
    });

    return _this;
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onSubmit = _this$props.onSubmit,
          onValidSubmit = _this$props.onValidSubmit,
          onInvalidSubmit = _this$props.onInvalidSubmit,
          onValuesChange = _this$props.onValuesChange,
          rest = _objectWithoutProperties(_this$props, ["onSubmit", "onValidSubmit", "onInvalidSubmit", "onValuesChange"]);

      return _react.default.createElement("div", null, _react.default.createElement("form", _extends({
        onSubmit: this.formSubmit
      }, rest), _react.default.createElement(_Context.default.Provider, {
        value: {
          registerField: this.registerField,
          validated: this.validated,
          valueChanged: this.valueChanged,
          unregisterField: this.unregisterField
        }
      }, this.props.children)));
    }
  }]);

  return Form;
}(_react.Component);

exports.default = Form;

_defineProperty(Form, "propTypes", {
  onValuesChange: _propTypes.default.func
});

_defineProperty(Form, "defaultProps", {
  onValuesChange: function onValuesChange() {}
});